import { useState } from "react";
import { gkFormUrl } from "@/mocks/formUrl";

type Status = "idle" | "loading" | "success" | "error";

export default function NewsletterForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    // honeypot check
    const honey = String(data.get("website_alt") || "").trim();
    if (honey) {
      setStatus("success");
      setMessage("订阅成功！每日新瓜将准时送到你的邮箱。");
      form.reset();
      return;
    }

    setStatus("loading");
    const body = new URLSearchParams();
    form.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>("input, textarea").forEach((field) => {
      const val = field.value.trim();
      if (field.name && val) body.append(field.name, val);
    });

    try {
      const res = await fetch(gkFormUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, any> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");
      if (res.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功！今日新瓜与每日瓜料将准时推送给你。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(typeof serverMsg === "string" && serverMsg ? serverMsg : "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络开小差了，请稍后重试。");
    }
  };

  return (
    <form id="subscribe-form" data-readdy-form onSubmit={handleSubmit} noValidate className="w-full max-w-md">
      <input type="text" name="website_alt" className="hp-field" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:rounded-full sm:bg-background-50 sm:p-1.5 sm:ring-1 sm:ring-background-200">
        <div className="flex flex-1 items-center gap-2 rounded-full bg-background-50 px-4 py-2.5 sm:bg-transparent sm:p-0 sm:px-3">
          <i className="ri-mail-line text-foreground-500"></i>
          <input type="email" name="email" required placeholder="请输入你的邮箱" className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400" />
        </div>
        <button
          type="submit"
          disabled={status === "loading"}
          className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
        >
          {status === "loading" ? "订阅中…" : "立即订阅"}
        </button>
      </div>
      <div aria-live="polite" className="mt-2 text-center text-xs sm:text-left">
        {status === "success" && <p className="text-accent-700">{message}</p>}
        {status === "error" && <p className="text-primary-700">{message}</p>}
        {status === "idle" && <p className="text-foreground-500">订阅即表示你同意接收看吃瓜的最新瓜料资讯，可随时退订。</p>}
      </div>
    </form>
  );
}